module.exports = __webpack_public_path__ + "img/kasiainsta.04e9015c.jpg";